import React from 'react';

import { subscriber_profile_path } from '../../routes';
import Pagination, { PaginationType } from '../BaseUI/Pagination';
import NoResultsMessage from '../shared/NoResultsMessage';
import ArticleOrBriefingFeedItem, { ArticleOrBriefing } from './ArticleOrBriefingFeedItem';
import { ArticleAuthors } from './AuthorsLine';
import { EntityTopic } from './EntityTopics';
import styles from './styles.module.scss';

export type ArticleOrBriefingDataContent = {
  entityTopics: EntityTopic[];
  authors: ArticleAuthors;
  highlightSlug?: string;
  excerpt: { short: string; long: string };
  type: 'Article' | 'Briefing';
};

export type ArticleData = Record<number, ArticleOrBriefingDataContent>;

export default function Feed({
  articleData,
  articlesOrBriefings,
  commentCounts,
  paginationData,
  useLargeImage,
  username,
}: {
  articleData: ArticleData;
  articlesOrBriefings: ArticleOrBriefing[];
  commentCounts: { [key: number]: number };
  paginationData?: PaginationType;
  useLargeImage?: boolean;
  username?: string;
}) {
  const getPath = (page: number) =>
    subscriber_profile_path(username, page === 1 ? undefined : page);

  return (
    <div>
      {articlesOrBriefings.length > 0 ? (
        <div className={styles.articles}>
          {articlesOrBriefings.map((articleOrBriefing, i) => (
            <div className={styles.article} key={articleOrBriefing.id} data-test="feed-item">
              <ArticleOrBriefingFeedItem
                articleOrBriefing={articleOrBriefing}
                articleOrBriefingData={articleData[articleOrBriefing.id]}
                commentCount={commentCounts[articleOrBriefing.id]}
                useFeaturedLayout={(i + 1) % 4 === 0}
                useLargeImage={useLargeImage}
              />
            </div>
          ))}
        </div>
      ) : (
        <NoResultsMessage />
      )}
      {paginationData?.totalPages > 1 && (
        <Pagination paginationData={paginationData} getPath={getPath} />
      )}
    </div>
  );
}
